import React, { useState } from 'react';
import ExpandText from '../../../../components/ExpandText/ExpandText';
import { InterpretationCompetency } from '../../../InterpretationCompetency/InterpretationCompetency';
import ModalPortal from '../../../ModalPortal/ModalPortal';
import style from './style/editablecompetencyprofile.scss';
import PagedCompetencies from '../../../../components/CompetencyProfileExtended/components/PagedCompetencies/PagedCompetencies';

export const EditableCompetencyProfile = ({ languageId, i18n, reportData, saveCompetency, saveInterval, initials }) => {
    const [showInterpretationCompetenciesModal, setShowInterpretationCompetenciesModal] = useState(false);
    const [selectedCompetency, setSelectedCompetency] = useState(null);

    const handleOpenInterpretationCompetenciesModal = (competency) => {

        // dont open modal in edit mode
        if (saveCompetency) {
            return null;
        }

        setSelectedCompetency(competency);
        setShowInterpretationCompetenciesModal(true);
    };

    const handleCloseInterpretationCompetenciesModal = () => {
        setShowInterpretationCompetenciesModal(false);
    };

    const getCompetencies = () => {
        if (!reportData?.sections?.competencyProfile?.competencies?.length) {
            return null;
        }

        return reportData.sections.competencyProfile.competencies.map((competency, index) =>
            <InterpretationCompetency
                key={index}
                competency={competency}
                languageId={languageId}
                i18n={i18n}
                reportData={reportData}
                saveCompetency={saveCompetency}
                saveInterval={saveInterval}
                openInterpretationCompetenciesModal={handleOpenInterpretationCompetenciesModal}
                initials={initials}
            />);
    };

    const getActiveCompetencyHandle = () => selectedCompetency?.handle || reportData?.sections?.competencyProfile?.competencies[0]?.handle;

    return <>
        <ExpandText
            text={reportData?.sections?.competencyProfile?.introduction}
            classes={{
                root: style.introductionText
            }}
            resize={null}
            index={1}
            handle={'competencyProfile'}
            expanded={false}
        />
        <div className={style.editableCompetencyProfile}>
            <ul>
                {getCompetencies()}
            </ul>
        </div>

        { /* to clarify: this renders to the modal portal entry point #report_modal */}
        <ModalPortal
            isOpen={showInterpretationCompetenciesModal}
            onClose={() => {
                handleCloseInterpretationCompetenciesModal();
            }}
        >
            {reportData?.sections?.competencyProfile?.competencies && <PagedCompetencies
                competencies={reportData?.sections?.competencyProfile?.competencies}
                active={getActiveCompetencyHandle()}
                closeCompetencyExtendedModal={handleCloseInterpretationCompetenciesModal}
                i18n={i18n}
                languageId={languageId}
                classes={{
                    pagedCompetenciesContent: style.pagedCompetenciesContent
                }}
                reportData={reportData}
                initials={initials}
            />}
        </ModalPortal>
    </>;
};
